// extracted by mini-css-extract-plugin
module.exports = {"container":"AsideHeader-module__container","resetData":"AsideHeader-module__resetData","mobileHEdingStyle":"AsideHeader-module__mobileHEdingStyle"};